import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    marginBottom: 24,
  },
  triggerButton: {
    width: 'fit-content',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: 575,
  },
  tabsBox: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  panel: {
    width: '100%',
  },
  overTimePanel: {
    minHeight: 500,
  },
  structurePanel: {
    minHeight: 250,
    marginTop: 120,
  },
}), { name: 'PortfolioChartsToggleDesktop', index: StylesIndexInjections.OTHER });

